import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    menu: {
      top: '40px !important',
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      minWidth: 190,
      maxWidth: 230,
    },
    menuList: {
      padding: 0,
    },

    headerText: {
      fontSize: 14,
      fontWeight: 'bold',
      color: palette.darkGray,
    },
    headerIcon: {
      minWidth: 0,
      marginLeft: 16,

      '& svg': {
        fontSize: 20,
      },
    },

    footer: {
      backgroundColor: palette.lightGray,
      borderTop: '1px solid rgba(0, 0, 0, .1)',
      paddingTop: 0,
      paddingBottom: 0,
      height: 33,
    },
    footerText: {
      fontSize: 14,
      fontWeight: 500,
    },
  });
